<template>
  <div class="row">
    <FileField
      v-model="file"
      name="file"
      :description="__('entities.logo-upload-filetypes')"
      :label="__('common.files')"
      class="col-12"
      accept="image/jpeg, image/png, image/gif"
      required
    />

    <div class="col-12">
      <b-row align-h="end">
        <b-col cols="auto">
          <b-button
            variant="primary"
            class="mr-2"
            size="sm"
            data-testid="import-btn"
            :disabled="!file"
            @click="importFiles"
          >
            <Icon icon="cloud-upload" class="mr-2" size="14" />
            {{ __('buttons.upload') }}
          </b-button>

          <b-button
            variant="outline-secondary"
            size="sm"
            data-testid="cancel-import-btn"
            @click="closeModal"
          >
            <Icon icon="times" class="mr-2" size="14" />
            {{ __('buttons.cancel') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ModalMixin from '@/General/Modal/ModalMixin.js'

export default {
  name: 'UploadLogoModal',

  mixins: [ModalMixin],

  data() {
    return {
      file: null,
    }
  },

  methods: {
    importFiles() {
      let formData = new FormData()

      formData.append('file', this.file)

      this.meta.uploadCallback &&
        this.meta
          .uploadCallback(formData)
          .then((response) => {
            this.closeModal()
            this.onSuccess && this.onSuccess(response.data)
          })
          .catch((error) => this.setErrorsFromResponse(error))
    },
  },
}
</script>
